import { io, Socket } from 'socket.io-client';
import type { ClientToServerEvents, ServerToClientEvents } from '@shared/types';

export type IDE_Socket = Socket<ServerToClientEvents, ClientToServerEvents>;

class WebSocketManager {
  private socket: IDE_Socket | null = null;
  private connectionPromise: Promise<IDE_Socket> | null = null;

  async connect(): Promise<IDE_Socket> {
    if (this.socket?.connected) {
      return this.socket;
    }

    if (this.connectionPromise) {
      return this.connectionPromise;
    }

    this.connectionPromise = new Promise((resolve, reject) => {
      const socket: IDE_Socket = io({
        path: '/socket.io',
        transports: ['websocket', 'polling'],
      });

      socket.on('connect', () => {
        console.log('✅ WebSocket connected');
        this.socket = socket;
        resolve(socket);
      });

      socket.on('connect_error', (error) => {
        console.error('❌ WebSocket connection error:', error);
        reject(error);
      });

      socket.on('disconnect', () => {
        console.log('🔌 WebSocket disconnected');
        this.socket = null;
        this.connectionPromise = null;
      });
    });

    return this.connectionPromise;
  }

  getSocket(): IDE_Socket | null {
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connectionPromise = null;
    }
  }
}

export const wsManager = new WebSocketManager();
